import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IGoal } from '../../major_explorer_interface';

angular
  .module('major-explorer-data')
  .service('saveListSelectionSubjectCommand', ($http: ng.IHttpService, defineCommand: IDefineCommand) => {
    return defineCommand(
      'saveListSelectionSubjectCommand',
      (deferred: ng.IDeferred<any>, subjectinterestSorted: any) => {
        const payload = {
          subjectinterest: {}
        };

        _4.forEach(subjectinterestSorted, (interest: IGoal, key: string) => {
          payload.subjectinterest[interest.id] = {
            id: interest.id,
            selected: _4.isUndefined(interest._selected) ? false : interest._selected
          };
        });

        $http.post('/programpicker/student/subject/', payload).then(
          ({ data }) => {
            deferred.resolve(data);
          },
          ({ data }) => {
            deferred.reject(data);
          }
        );
      }
    );
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/save_list_selection_subject_command.ts